// **********************************************************
// Product Showcase
// **********************************************************
const productShowcaseMain = document.querySelectorAll('[data-slider="product-showcase-main"]');
const productShowcaseThumb = document.querySelectorAll('[data-slider="product-showcase-thumb"]');

// *******************************************************************************
// 1.1 - Product Thumb Slider
// *******************************************************************************

const productShowcaseThumbSliderOptions = {
  slidesPerView: 4,
  spaceBetween: 0,
  watchOverflow: true,
  centerInsufficientSlides: true,
  speed: 600,
  breakpoints: {
    1023: {
      slidesPerView: 5,
      spaceBetween: 0,
    },
  },
};

productShowcaseThumb.forEach((el) => new Swiper(el, productShowcaseThumbSliderOptions));

// *******************************************************************************
// 1.2 -Product Main Slider
// *******************************************************************************

const productShowcaseMainOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  loop: true,
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
};

productShowcaseMain.forEach((el, i) => {
  const productShowcaseMainParent = el.closest('.product-showcase');
  const arrowRight = productShowcaseMainParent.querySelector('.arrow-right');
  const arrowLeft = productShowcaseMainParent.querySelector('.arrow-left');
  const paginationElement = productShowcaseMainParent.querySelector('.swiper-pagination');

  productShowcaseMainOptions.navigation.nextEl = arrowRight;
  productShowcaseMainOptions.navigation.prevEl = arrowLeft;
  productShowcaseMainOptions.pagination.el = paginationElement;

  productShowcaseMainOptions.thumbs.swiper = productShowcaseThumb[i].swiper;

  new Swiper(el, productShowcaseMainOptions);
});
